module.exports = __webpack_public_path__ + "img/advance-down.9ea26839.svg";